import { render, staticRenderFns } from "./VoucherProtection.vue?vue&type=template&id=36327a70&scoped=true"
import script from "./VoucherProtection.vue?vue&type=script&lang=js"
export * from "./VoucherProtection.vue?vue&type=script&lang=js"
import style0 from "./VoucherProtection.vue?vue&type=style&index=0&id=36327a70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36327a70",
  null
  
)

export default component.exports